import type { ReactElement, ReactNode } from "react"
import { createContext, useContext } from "react"

export type BreadcrumbItem = {
  label: string
  url?: string
}

export type BreadcrumbsContextValue = {
  homeUrl: string
  items: BreadcrumbItem[]
  currentLabel?: string
}

export const BreadcrumbsContext = createContext<
  BreadcrumbsContextValue | undefined
>(undefined)

export const useBreadcrumbsContext = () => useContext(BreadcrumbsContext)

type BreadcrumbsContextProviderProps = BreadcrumbsContextValue & {
  children: ReactNode
}

export function BreadcrumbsContextProvider({
  homeUrl,
  items,
  currentLabel,
  children,
}: BreadcrumbsContextProviderProps): ReactElement<BreadcrumbsContextProviderProps> {
  return (
    <BreadcrumbsContext.Provider value={{ homeUrl, items, currentLabel }}>
      {children}
    </BreadcrumbsContext.Provider>
  )
}

export default BreadcrumbsContext
